import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { applicationConstants } from 'src/app/constants';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import { environment } from 'src/environments/environment';
import * as CONSTANTS from '../../constants';


@Component({
  selector: 'demo-ecif-validation',
  templateUrl: './demo-ecif-validation.html'
})
export class DemoEcifValidation implements OnInit {
  applicant: boolean;
  preQualObj: any;
  addressArrayRequestBody: any = [];
  showAddressPopup: boolean = false;
  isCoapplicantApplied: boolean;
  isExistingCustomer: boolean;
  areBothCibcCustomer: boolean;
  demoFlowVariable: string = "singleFlow"
  addressObject: { addresses: any; };
  responseAddress: any;
  addressSuggestionResponse: any;

  constructor(private utilService: UtilService, private router: Router, private _activatedRoute: ActivatedRoute) {
    this.utilService.isSidebarVisible.next(false);
  }

  ngOnInit(): void {
    this.preQualObj = this.utilService.getSessionStorage();
    this.isCoapplicantApplied = this.preQualObj.is_coapplicant_applied == 'Y' ? true : false;
    this.isExistingCustomer = this.preQualObj.is_existing_bankcustomers == 'Y' ? true : false;
    this.areBothCibcCustomer = this.preQualObj.are_both_applicants_CIBC_customer == 'Y' ? true : false;
    if (this.isCoapplicantApplied && !this.isExistingCustomer) {
      this.demoFlowVariable = "doubleFlow";
    }
    let addressObj = {
      "addressFields": {}
    };
    this.preQualObj.users.forEach(user => {
      addressObj.addressFields['street'] = user.addressline1;
      addressObj.addressFields['city'] = user.city;
      addressObj.addressFields['provinceState'] = user.province;
      addressObj.addressFields['postalCode'] = user.postal_code;
      addressObj.addressFields['country'] = user.country_code;
      addressObj.addressFields['propertyName'] = "",
        addressObj.addressFields['postalRural'] = "",
        addressObj.addressFields['foreignAddressInfo'] = "",

        this.addressArrayRequestBody.push({ ...addressObj.addressFields });
    });
    this.addressObject = {
      "addresses": this.addressArrayRequestBody
    };
  }

  ecifResponse(status) {
    this.utilService.demoGetEcifResponse(this.addressObject).subscribe((res) => {
      this.responseAddress = res;
      this.addressSuggestionResponse = this.responseAddress.addresses;
      // console.log("addressData=>", this.addressSuggestionResponse.address);
      // this.addressSuggestionResponse = this.addressSuggestionResponse.address;

      // (FLOW 1) --> two customers are there condition

      if (this.isCoapplicantApplied && !this.isExistingCustomer) {
        //both passed flow --> route to contact
        console.log("entering two cus not in cibc flow")
        if (this.responseAddress.operationMetaData.status[0].statusCode === '00000' && this.responseAddress.operationMetaData.status[1].statusCode === '00000') {
          this.addressSuggestionResponse.forEach((address, index) => {
            if (index === 0) {
              this.preQualObj.users[index]['address_api_certificate'] = address.addressAPICertificate;
            } else {
              this.preQualObj.users[index]['address_api_certificate'] = address.addressAPICertificate;
            }
          })
          console.log("two customer exact match flow");
          this.router.navigate(['../personal-information-contact'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });

          //one of them address valid flow --> suggest address for one of them
        } else if (this.responseAddress.operationMetaData.status[0].statusCode === '00000' || this.responseAddress.operationMetaData.status[1].statusCode === '00000') {
          console.log("entering two customer flow with one address suggesstion");
          var deleteExactMatchUser = null;
          if (this.responseAddress.operationMetaData.status.forEach((statusObj, index) => {
            if (statusObj.statusCode === '00000') {
              this.preQualObj.users[index]['address_api_certificate'] = this.addressSuggestionResponse[index].addressAPICertificate;
              deleteExactMatchUser = index
              console.log("delete the exact match user index", deleteExactMatchUser);
            } else {
              this.addressSuggestionResponse[index]["main_application"] = index;
            }
          }))
            console.log("delete the exact match user index outside if", deleteExactMatchUser);
          if (deleteExactMatchUser != null) {
            console.log("is one data being deleted? ektering?>")
            this.addressSuggestionResponse.splice(deleteExactMatchUser, 1);
          }
          this.showAddressPopup = true;
        }
        //both suggesting flow --> suggest address for both 
        else {
          console.log("two customer suggesting address");
          this.addressSuggestionResponse.forEach((userAddress, index) => {
            if (index === 0) {
              this.addressSuggestionResponse[index]["main_application"] = 0;
            } else {
              this.addressSuggestionResponse[index]["main_application"] = 1;
            }
          })
          this.showAddressPopup = true;
        }

        // (FLOW 2) --> one customer is there
      } else {
        // address exact match --> route to contact
        if (this.responseAddress.operationMetaData.status[0].statusCode === '00000') {
          console.log("single applicant or co applicant exact match")
          if (!this.isCoapplicantApplied) {
            this.preQualObj.users[0]['address_api_certificate'] = this.responseAddress.addresses[0].addressAPICertificate;
            this.utilService.setSessionStorage(this.preQualObj);
          }
          if (this.isCoapplicantApplied) {
            this.preQualObj.users[1]['address_api_certificate'] = this.responseAddress.addresses[0].addressAPICertificate;
          }
          setTimeout(() => {
            this.router.navigate(['../personal-information-contact'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
          })
        }
        // address suggest for applicant or co applicant (only one, id passed)
        else {
          console.log("entering one of them flow")
          if (!this.isCoapplicantApplied || !this.isExistingCustomer) {
            console.log("entering single applicant flow suggesting")
            this.addressSuggestionResponse[0]["main_application"] = 0;
            this.showAddressPopup = true;
          }
          if (this.isCoapplicantApplied || this.isExistingCustomer) {
            console.log("entering one of them coapplicant data entry flow suggesting")
            this.addressSuggestionResponse[0]["main_application"] = 1;
            this.showAddressPopup = true;
          }
        }
      }
      console.log("after mapping the address to applicants", this.addressSuggestionResponse);
      console.log("after mapping prequal obj", this.preQualObj);
      this.utilService.setSessionStorage(this.preQualObj);

    }, (error) => {
      console.log("entering error scenario from demo page")
      // this.utilService.saveError(this.preQualObj, error).subscribe(data => {
      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      // });
    });
  }

  closeModal() {
    this.showAddressPopup = false;
  }

  onContinuePopup() {
    this.router.navigate(['../personal-information-contact'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
  }

  receivedAddress(addressArray: any) {
    const addressFields = ['street', 'city', 'province', 'postalCode'];
    this.showAddressPopup = false;
    console.log("parentttt address array", addressArray);

    addressArray.forEach(item => {
      const splitAddress = item.selectedAddress.split(',').map(val => val.trim());

      let populatedAddressObj = {};
      for (let i = 0; i < addressFields.length; i++) {
        populatedAddressObj[addressFields[i]] = splitAddress[i] || '';
      }

      console.log("populated address", populatedAddressObj);
      this.preQualObj.users[item.main_application].addressline1 = populatedAddressObj["street"];
      this.preQualObj.users[item.main_application].city = populatedAddressObj["city"];
      this.preQualObj.users[item.main_application].province = populatedAddressObj["province"];
      this.preQualObj.users[item.main_application].postal_code = populatedAddressObj["postalCode"];

      this.preQualObj.users[item.main_application]["address_api_certificate"] = item.addressCertificate;


    });

    console.log("after updation", this.preQualObj);
    this.utilService.setSessionStorage(this.preQualObj);
    this.router.navigate(['../personal-information-contact'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
  }
}


